import { isJingguiOrg } from './org';

const FAVICON = {
  jinggui: '/favicon-jinggui.png',
  default: '/favicon.ico',
} as const;

const PAGE_TITLE = {
  jinggui: '京桂人工智能',
  default: '目异同学',
} as const;

function faviconMimeType(href: string): string {
  if (href.endsWith('.ico')) return 'image/x-icon';
  if (href.endsWith('.svg')) return 'image/svg+xml';
  return 'image/png';
}

/** Apply tenant favicon + document title from Vite env (`VITE_CASDOOR_ORG_NAME`). */
export function applyTenantBranding(): void {
  const jinggui = isJingguiOrg();
  const faviconHref = jinggui ? FAVICON.jinggui : FAVICON.default;
  const title = jinggui ? PAGE_TITLE.jinggui : PAGE_TITLE.default;

  document.title = title;

  let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  link.type = faviconMimeType(faviconHref);
  link.href = faviconHref;
}
